export const IfConditionIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
    <g clipPath="url(#clip0_5200_13614)">
      <path d="M0.5 6V1H5.5" stroke="#151515" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M15.5 6V1H10.5" stroke="#151515" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M0.5 1L7.5 8V16" stroke="#151515" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M15.5 1L9.5 7" stroke="#151515" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
  <defs>
    <clipPath id="clip0_5200_13614">
      <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
    </clipPath>
  </defs>
  </svg>
)
